import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import "../styles/application.css"

// Start Stimulus and auto-register every controller under app/frontend/controllers.
const application = Application.start()
application.debug = false
window.Stimulus = application

const controllers = import.meta.glob("../controllers/*_controller.js", { eager: true })
for (const path in controllers) {
  const name = path
    .split("/")
    .pop()
    .replace("_controller.js", "")
    .replace(/_/g, "-")
  application.register(name, controllers[path].default)
}
